import { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { Separator } from '@/components/ui/separator';

import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger
} from '@/components/ui/collapsible';
import { useCart } from '@/data/cart';
import CartItem from '@/app/cartItem/CartItem';

import { currencyFormat } from '@/helpers/stringHelpers';

const CollapsibleCartItems = ({ cartId }) => {
  const cart = useCart(cartId);
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <Collapsible open={isOpen} onOpenChange={setIsOpen}>
        <CollapsibleTrigger className="flex justify-between items-center w-full  mb-4">
          <div className="flex items-center gap-2">
            <ChevronDown
              className={`h-6 w-6 transition-transform duration-200 ${
                isOpen ? 'rotate-180' : ''
              }`}
            />
            <div>
              Order Summary ({cart.data?.items.length}{' '}
              {cart.data?.items.length === 1 ? 'item' : 'items'})
            </div>
          </div>
          <div>{currencyFormat(cart.data?.subTotal)}</div>
        </CollapsibleTrigger>
        <CollapsibleContent>
          <div className="space-y-4 py-4">
            {cart.data.items.map((cartItem) => (
              <CartItem cartItem={cartItem} key={cartItem.id} />
            ))}
          </div>
        </CollapsibleContent>
      </Collapsible>
      <div className="space-y-2 text-sm">
        {isOpen && (
          <>
            <Separator className="mb-4" />
            <div className="flex justify-between">
              <span>Subtotal</span>
              <span>{currencyFormat(cart.data.subTotal)}</span>
            </div>
          </>
        )}
        {cart.data.taxSummary.map((tax) => (
          <div
            key={tax.label}
            className="flex justify-between text-muted-foreground"
          >
            <span>{tax.label}</span>
            <span>{currencyFormat(tax.totalAmount)}</span>
          </div>
        ))}
        <div className="flex justify-between font-medium text-base">
          <span>Total</span>
          <span>{currencyFormat(cart.data.total)}</span>
        </div>
      </div>
    </>
  );
};

export default CollapsibleCartItems;
